import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./consent-banner.css";

const CONSENT_KEY = "analyticsConsent";

export default function ConsentBanner() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const consent = localStorage.getItem(CONSENT_KEY);

    if (token && consent !== "accepted" && !location.pathname.startsWith("/logout") && !location.pathname.startsWith("/login")) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [location.pathname]);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);

    if (window.gtag) {
      window.gtag("consent", "update", {
        analytics_storage: "granted",
        ad_storage: "denied",
      });

      window.gtag("event", "page_view", {
        page_path: window.location.pathname,
      });
    }
  };

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);

    if (window.gtag) {
      window.gtag("consent", "update", {
        analytics_storage: "denied",
        ad_storage: "denied",
      });
    }
  };

  if (!visible) return null;

  return (
    <div className="consent-banner">
      <p className="consent-text">
        We use analytics to understand usage of Lassie. No personal or marketing
        data is collected.
      </p>

      <div className="consent-actions">
        <button className="consent-button decline" onClick={decline}>
          Decline
        </button>
        <button className="consent-button accept" onClick={accept}>
          Accept
        </button>
      </div>
    </div>
  );

}
